// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"c4bdc884","867":"beeb73b7"}[chunkId] + ".chunk.js";
};